<ng-container *ngIf="externalSettings == null"></ng-container>

<ng-container *ngIf="externalSettings != null">
  <div class="mt-2 flex-fill sidebar-container">           
    <div id="sidebar-content" class="bg-white d-inline-block w-100 pt-2 field-box">
      <div class="width-full" *ngIf="this.menu">
        <ng-container *ngFor="let section of this.menu.sections | keyvalue: compareFn">
          <app-sidebar-group *ngFor="let group of section.value.groups" [group]="group">
          </app-sidebar-group>
        </ng-container>
      </div>
    </div>
  
    <ng-container *ngIf="banner">
      <div class="text-center w-100 my-4">
        <img *ngIf="banner.image" class="img-fluid rounded" 
        [src]="banner.image" 
        [alt]="banner.name" 
        [title]="banner.name" 
        (click)="this.accessBanner()"
        [ngClass]="banner.link ? 'cursor-pointer' : ''">
      </div>
    </ng-container>
  
  </div>
</ng-container>
